<template>
  <div
    class="header-apportion-informations"
    style="display: flex; margin-top: -10px"
  >
    <div
      style="
        margin-right: 20px;
        width: 500px;
        display: flex;
        flex-direction: column;
      "
    >
      <div style="display: flex; justify-content: space-between">
        <span style="font-weight: bold">Rateio indireto disponível</span>
        <div style="width: 55%; display: flex">
          <span v-if="apportionment.total_available">{{
            apportionment.total_available.toLocaleString(constants.language, {
              style: "currency",
              currency: constants.currency,
            })
          }}</span>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between">
        <span style="font-weight: bold">Rateio indireto planejado</span>
        <div style="width: 55%; display: flex">
          <span v-if="apportionment.total_planned">{{
            apportionment.total_planned.toLocaleString(constants.language, {
              style: "currency",
              currency: constants.currency,
            })
          }}</span>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between">
        <span style="font-weight: bold">Total rateado</span>
        <div style="width: 55%; display: flex">
          <span v-if="apportionment.total_used">{{
            apportionment.total_used.toLocaleString(constants.language, {
              style: "currency",
              currency: constants.currency,
            })
          }}</span>

          <el-progress
            style="width: 140px; margin-left: 20px"
            v-if="apportionment.percent_used"
            :text-inside="false"
            :stroke-width="10"
            :percentage="parseFloat(formatterNumber(apportionment.percent_used))"
            :color="
              apportionment.status !== constants.status.closed
                ? '#e87305'
                : 'rgb(117, 117, 117)'
            "
          />
        </div>
      </div>
    </div>
    <div style="align-self: flex-start; margin-left: 40px">
      <div>
        <span style="margin-right: 70px; font-weight: bold">Status</span>
        <span>{{
          apportionment.status === constants.status.opened
            ? "Aberto"
            : apportionment.status === constants.status.closed
            ? "Concluído"
            : "Aguardando importação"
        }}</span>
      </div>
      <div style="">
        <span style="margin-right: 50px; font-weight: bold">Diferença</span>
        <span v-if="apportionment.total_planned && apportionment.total_used">{{
          (
            apportionment.total_planned - apportionment.total_used
          ).toLocaleString(constants.language, {
            style: "currency",
            currency: constants.currency,
          })
        }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.header-apportion-informations {
  margin-top: 40px;
  font-size: 13px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>

<script>
import constants from "../utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "HeaderApportionment",
  template: "#HeaderApportionment",
  props: {
    apportionment: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      constants: constants,
    };
  },
  computed: {
    ...mapGetters(["formatterNumber"]),
  },
};
</script>
